"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBComAttributeSchemas = void 0;
const accordion_schema_1 = require("./attributes/accordion.schema");
const anchor_schema_1 = require("./attributes/anchor.schema");
const audio_language_schema_1 = require("./attributes/audio-language.schema");
const authorship_schema_1 = require("./attributes/authorship.schema");
const call_to_action_schema_1 = require("./attributes/call-to-action.schema");
const contextual_schema_1 = require("./attributes/contextual.schema");
const date_time_schema_1 = require("./attributes/date-time.schema");
const date_year_schema_1 = require("./attributes/date-year.schema");
const date_schema_1 = require("./attributes/date.schema");
const duration_schema_1 = require("./attributes/duration.schema");
const enumeration_schema_1 = require("./attributes/enumeration.schema");
const external_reference_schema_1 = require("./attributes/external-reference.schema");
const fact_schema_1 = require("./attributes/fact.schema");
const featured_partners_schema_1 = require("./attributes/featured-partners.schema");
const info_block_group_schema_1 = require("./attributes/info-block-group.schema");
const info_block_schema_1 = require("./attributes/info-block.schema");
const info_snippet_schema_1 = require("./attributes/info-snippet.schema");
const key_value_schema_1 = require("./attributes/key-value.schema");
const legal_disclaimer_schema_1 = require("./attributes/legal-disclaimer.schema");
const location_schema_1 = require("./attributes/location.schema");
const paragraph_container_schema_1 = require("./attributes/paragraph-container.schema");
const paragraph_schema_1 = require("./attributes/paragraph.schema");
const partner_hosted_live_stream_schema_1 = require("./attributes/partner-hosted-live-stream.schema");
const partner_streams_schema_1 = require("./attributes/partner-streams.schema");
const question_and_answers_schema_1 = require("./attributes/question-and-answers.schema");
const quote_schema_1 = require("./attributes/quote.schema");
const reference_link_schema_1 = require("./attributes/reference-link.schema");
const related_content_container_schema_1 = require("./attributes/related-content-container.schema");
const results_table_schema_1 = require("./attributes/results-table.schema");
const sub_page_schema_1 = require("./attributes/sub-page.schema");
const table_container_schema_1 = require("./attributes/table-container.schema");
const table_schema_1 = require("./attributes/table.schema");
const text_schema_1 = require("./attributes/text.schema");
const textual_artefact_container_schema_1 = require("./attributes/textual-artefact-container.schema");
const time_table_schema_1 = require("./attributes/time-table.schema");
const timestamp_schema_1 = require("./attributes/timestamp.schema");
const track_record_schema_1 = require("./attributes/track-record.schema");
const web_link_schema_1 = require("./attributes/web-link.schema");
exports.RBComAttributeSchemas = [
    accordion_schema_1.AccordionSchema,
    anchor_schema_1.AnchorSchema,
    audio_language_schema_1.AudioLanguageSchema,
    authorship_schema_1.AuthorshipSchema,
    call_to_action_schema_1.CallToActionSchema,
    contextual_schema_1.ContextualTextAttributeSchema,
    date_time_schema_1.DateTimeSchema,
    date_year_schema_1.YearSchema,
    date_schema_1.DateSchema,
    duration_schema_1.DurationSchema,
    enumeration_schema_1.EnumerationSchema,
    external_reference_schema_1.ExternalReferenceSchema,
    fact_schema_1.FactSchema,
    featured_partners_schema_1.FeaturedPartnerSchema,
    info_block_group_schema_1.InfoBlockGroupSchema,
    info_block_schema_1.InfoBlockSchema,
    info_snippet_schema_1.InfoSnippetSchema,
    key_value_schema_1.KeyValueSchema,
    legal_disclaimer_schema_1.LegalDisclaimerSchema,
    location_schema_1.LocationAttributeSchema,
    paragraph_container_schema_1.ParagraphContainerSchema,
    paragraph_schema_1.ParagraphSchema,
    partner_hosted_live_stream_schema_1.PartnerHostedLiveStreamSchema,
    partner_streams_schema_1.PartnerStreamsSchema,
    question_and_answers_schema_1.QuestionAndAnswersSchema,
    quote_schema_1.QuoteSchema,
    reference_link_schema_1.ReferenceLinkSchema,
    related_content_container_schema_1.RelatedContentContainerSchema,
    results_table_schema_1.ResultsTableSchema,
    sub_page_schema_1.SubPageSchema,
    table_container_schema_1.TableContainerSchema,
    table_schema_1.TableSchema,
    text_schema_1.TextSchema,
    textual_artefact_container_schema_1.TextualArtefactContainerSchema,
    time_table_schema_1.TimeTableSchema,
    timestamp_schema_1.TimestampSchema,
    track_record_schema_1.TrackRecordSchema,
    web_link_schema_1.WebLinkSchema
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXR0cmlidXRlLnNjaGVtYXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGUuc2NoZW1hcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvRUFBK0Q7QUFDL0QsOERBQXlEO0FBQ3pELDhFQUF3RTtBQUN4RSxzRUFBaUU7QUFDakUsOEVBQXVFO0FBQ3ZFLHNFQUE4RTtBQUM5RSxvRUFBOEQ7QUFDOUQsb0VBQTBEO0FBQzFELDBEQUFxRDtBQUNyRCxrRUFBNkQ7QUFDN0Qsd0VBQW1FO0FBQ25FLHNGQUFnRjtBQUNoRiwwREFBcUQ7QUFDckQsb0ZBQTZFO0FBQzdFLGtGQUEyRTtBQUMzRSxzRUFBZ0U7QUFDaEUsMEVBQW9FO0FBQ3BFLG9FQUE4RDtBQUM5RCxrRkFBNEU7QUFDNUUsa0VBQXNFO0FBQ3RFLHdGQUFrRjtBQUNsRixvRUFBK0Q7QUFDL0Qsc0dBQThGO0FBQzlGLGdGQUEwRTtBQUMxRSwwRkFBbUY7QUFDbkYsNERBQXVEO0FBQ3ZELDhFQUF3RTtBQUN4RSxvR0FBNkY7QUFDN0YsNEVBQXNFO0FBQ3RFLGtFQUE0RDtBQUM1RCxnRkFBMEU7QUFDMUUsNERBQXVEO0FBQ3ZELDBEQUFxRDtBQUNyRCxzR0FBK0Y7QUFDL0Ysc0VBQWdFO0FBQ2hFLG9FQUErRDtBQUMvRCwwRUFBb0U7QUFDcEUsa0VBQTREO0FBRS9DLFFBQUEscUJBQXFCLEdBQWM7SUFDOUMsa0NBQWU7SUFDakIsNEJBQVk7SUFDWiwyQ0FBbUI7SUFDbkIsb0NBQWdCO0lBQ2hCLDBDQUFrQjtJQUNsQixpREFBNkI7SUFDN0IsaUNBQWM7SUFDZCw2QkFBVTtJQUNWLHdCQUFVO0lBQ1YsZ0NBQWM7SUFDZCxzQ0FBaUI7SUFDakIsbURBQXVCO0lBQ3ZCLHdCQUFVO0lBQ1YsZ0RBQXFCO0lBQ3JCLDhDQUFvQjtJQUNwQixtQ0FBZTtJQUNmLHVDQUFpQjtJQUNqQixpQ0FBYztJQUNkLCtDQUFxQjtJQUNyQix5Q0FBdUI7SUFDdkIscURBQXdCO0lBQ3hCLGtDQUFlO0lBQ2YsaUVBQTZCO0lBQzdCLDZDQUFvQjtJQUNwQixzREFBd0I7SUFDeEIsMEJBQVc7SUFDWCwyQ0FBbUI7SUFDbkIsZ0VBQTZCO0lBQzdCLHlDQUFrQjtJQUNsQiwrQkFBYTtJQUNiLDZDQUFvQjtJQUNwQiwwQkFBVztJQUNYLHdCQUFVO0lBQ1Ysa0VBQThCO0lBQzlCLG1DQUFlO0lBQ2Ysa0NBQWU7SUFDZix1Q0FBaUI7SUFDakIsK0JBQWE7Q0FDWixDQUFBIn0=